import { z } from 'zod';

// Strict, so a typo in a key fails loudly instead of silently dropping the text.
export const checkInContentSchema = z.strictObject({
  question: z.string(),
  scale: z.array(z.string()),
  after: z.string(),
});

export const mileCompleteSchema = z.strictObject({
  insights: z.array(z.strictObject({ kicker: z.string(), title: z.string(), body: z.string() })),
});

// arc.miles holds each mile's recap, in mile order.
export const journeyCompleteSchema = (milesCount: number) =>
  z.strictObject({
    arc: z.strictObject({
      eyebrow: z.string(),
      title: z.string(),
      miles: z.array(z.string()).length(milesCount, `needs one line per mile (${milesCount})`),
    }),
    takeaway: z.strictObject({ title: z.string(), text: z.string() }),
  });
